import React from 'react'
import classNames from 'classnames'
import { ImCheckmark, ImCross } from 'react-icons/im'
import styles from './tooltipMessage.module.scss'

export default ({ children, type, successIcon, errorIcon }) => {
  const icon =
    type === 'success' ? (
      successIcon ? (
        <img src={successIcon} />
      ) : (
        <ImCheckmark />
      )
    ) : errorIcon ? (
      <img src={errorIcon} />
    ) : (
      <ImCross />
    )
  return (
    <div className={classNames(styles.alert, styles[type])}>
      <span className={styles.icon}>{icon}</span>
      {children}
    </div>
  )
}

export const NoMarkTooltip = ({ children, type, bigger }) => {
  return (
    <div
      className={classNames(styles.alert, styles[type], {
        [styles.bigger]: bigger
      })}
    >
      {children}
    </div>
  )
}

export const NeutralTooltip = ({
  children,
  type,
  successIcon,
  errorIcon,
  shouldReserveSpace
}) => {
  const icon =
    type === 'success' ? (
      successIcon ? (
        <img src={successIcon} />
      ) : (
        <ImCheckmark />
      )
    ) : errorIcon ? (
      <img src={errorIcon} />
    ) : (
      <ImCross />
    )
  return (
    <div className={classNames(styles.alert, styles.neutral)}>
      {shouldReserveSpace && (
        <span className={classNames(styles.invisible, styles.icon)}>
          {icon}
        </span>
      )}
      {children}
      {!shouldReserveSpace && (
        <span className={classNames(styles.invisible, styles.icon)}>
          {icon}
        </span>
      )}
    </div>
  )
}
